import { render, staticRenderFns } from "./PeriodRateMaskItemNew.vue?vue&type=template&id=d4fc2064&scoped=true&"
import script from "./PeriodRateMaskItemNew.vue?vue&type=script&lang=js&"
export * from "./PeriodRateMaskItemNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4fc2064",
  null
  
)

export default component.exports